<template>
  <div class="series-checkboxes">
    <h3 v-if="showSubtitle">{{ $gettext('Series preferences') }}</h3>
    <sk-checkbox :item-text="interpreterAttendAllDatesText"
                 :preselected-value="seriesDateOneSupplierSelect"
                 :disabled="disabledFields"
                 class="series-checkboxes__item"
                 @checkboxvaluechanged="changeSeriesDateOneSupplierSelect" />
    <sk-checkbox :item-text="interpreterAttendAllLanguagesText"
                 :preselected-value="seriesLanguageOneSupplierSelect"
                 :disabled="disabledFields"
                 class="series-checkboxes__item"
                 @checkboxvaluechanged="setSeriesLanguageOneSupplierSelect" />
  </div>
</template>

<script>
  import {mapActions, mapState, mapMutations} from 'vuex';

  export default {
    props: {
      params: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    computed: {
      ...mapState('PostingStore/SeriesAssignmentStore', {
        seriesDateOneSupplierSelect: ({seriesDateOneSupplierSelect}) => seriesDateOneSupplierSelect,
        seriesLanguageOneSupplierSelect: ({seriesLanguageOneSupplierSelect}) => seriesLanguageOneSupplierSelect,
      }),
      showSubtitle() { return this.params.showSubtitle || false; },
      disabledFields() { return this.params.disabledFields; },
      interpreterAttendAllDatesText() { return this.$gettext('Find interpreters who can attend all dates'); },
      interpreterAttendAllLanguagesText() { return this.$gettext('For jobs at the same time, invite interpreters who can speak all languages'); },
    },
    methods: {
      ...mapActions('PostingStore/SeriesAssignmentStore', ['changeSeriesDateOneSupplierSelect']),
      ...mapMutations('PostingStore/SeriesAssignmentStore', ['setSeriesLanguageOneSupplierSelect'])
    }
  };
</script>

<style scoped>
  h3 {
    margin: 24px 0 16px;
  }

  .series-checkboxes__item {
    margin-bottom: 16px;
  }
</style>
